import NextLink from 'next/link'
import Button from '../Button'
import Box from '../Box'

const LinkButton = ({ children, ...rest }) => {
  return (
    <Button {...rest} component={NextLink}>
      {children}

      {rest.target === '_blank' && (
        <Box
          component="span"
          sx={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: '0',
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            border: '0',
          }}
        >
          (opens in a new tab)
        </Box>
      )}
    </Button>
  )
}

export default LinkButton
